// QUANTITY COUNTER PRODUCT

$( document ).on( 'click', '.qty-plus', function() {
  console.log("come on");
      var input = $( this ).prev( 'input' );
      var step = typeof input.attr( 'step' ) == 'undefined' ? 1 : parseInt( input.attr( 'step' ) );
      var max = typeof input.attr( 'max' ) == 'undefined' ? false : parseInt( input.attr( 'max' ) );
      var value = parseInt( input.val() );
      if( isNaN( max ) ) {
        max = false;
      }
      value+= step;
      if( max && ( value > max) ) { 
        value  = max;
      }
      input.val( value );
      input.trigger( 'change' );
  });
  
    $( document ).on( 'click', '.qty-minus', function() {
      var input = $( this ).next( 'input' );
      var step = typeof input.attr( 'step' ) == 'undefined' ? 1 : parseInt( input.attr( 'step' ) );
      var min = typeof input.attr( 'min' ) == 'undefined' ? 1 : parseInt( input.attr( 'min' ) );
      if( isNaN( min ) ) {
        min = 1;
      }
      var value = parseInt( input.val() );
      value-= step;
      if( value < min ) {
        value  = min;
      }
      input.val( value );
      input.trigger( 'change' );
    });


    // READ MORE PRODUCT DESCRIPTION

    $( document ).on( 'click', '.read-more', function() {
      $('.prod-desc').toggleClass('read-more-height')
      $('.read-more svg').toggleClass('chevron-rotate')
      console.log('click')
     });


    //  CURRENCY SELECTOR JS

    $( document ).ready(function() {
   
      $('select#country_select').on('change', function() {
        // depending on option selected, send user to that particular website (TO DO when other site goes live)
      switch (this.value) {
        case 'US':
          // send to us site
          break;
        case 'GBP':
            // send to UK site
           break;
        default:
          break;
      }
        console.log( this.value );
      });


    });


    // instafeed css through js - have to wait till code is loaded via app


function instafeedStyling() {

    $('#insta-feed div').children('span.slide-page').each(function( index ) {

      if (index % 2 == 0) {
        // odd
        const el = $(this).find('.instafeed-container')

        $(el).css('margin-top','-2.5%')
        $(el).css('padding-top','23%')
      }

    });

  }

    function waitForElement(selector, delay = 1000, tries = 10) {
      const element = document.querySelector(selector);
      // creates a local variable w/ the name of the selector to keep track of all tries
      if (!window[`__${selector}`]) {
        window[`__${selector}`] = 0;
      }

      function _search() {
        return new Promise((resolve) => {
          window[`__${selector}`]++;
          console.log(window[`__${selector}`]);
          setTimeout(resolve, delay);
        });
      }

      //element not found, retry
      if (element === null) {
        if (window[`__${selector}`] >= tries) {
          window[`__${selector}`] = 0;
          return Promise.reject(null);
        }

        return _search().then(() => waitForElement(selector));
      } else {
        return Promise.resolve(element);
      }
    }
     
    async function wait(){ 
        try{
        // Just slap whatever element you are waiting to exist in here:
            const $el = await waitForElement("#insta-feed");
        // Then do what you need to
          console.log('loaded')
          setTimeout(() => {
            instafeedStyling();
          }, 500);
 
      } catch(err){
            console.error("Timeout - couldn't find element.")
        }
    }
    // call the function
    wait();



    // PARLOUR BUTTON GOOGLE MAPS OPEN JS
    $( document ).ready(function() {
    $('button.parlour_dir_btn').click((event) => {
      // get the user input
      const user_location = $(event.target).prev().val()
      console.log(user_location)
      // get location of parlour specifc
      const parlour_long = $(event.target).parent().parent().find('.longitude').text()
      const parlour_lat = $(event.target).parent().parent().find('.latitude').text()

      // open the google maps page with drections
      url = 'https://www.google.com/maps/dir/?api=1&origin=' + user_location + '&destination=' + parlour_lat + ',' + parlour_long
      console.log(url)
      window.open(url, '_blank').focus();
    })
  })